export const MailIcon = ({ color = "#6A7282" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.83333 14.4867C8.03603 14.6037 8.26595 14.6653 8.5 14.6653C8.73405 14.6653 8.96397 14.6037 9.16667 14.4867L13.8333 11.82C14.0358 11.7031 14.204 11.535 14.321 11.3326C14.438 11.1301 14.4998 10.9005 14.5 10.6667V5.33333C14.4998 5.09952 14.438 4.86987 14.321 4.66744C14.204 4.46501 14.0358 4.29691 13.8333 4.18L9.16667 1.51333C8.96397 1.39631 8.73405 1.3347 8.5 1.3347C8.26595 1.3347 8.03603 1.39631 7.83333 1.51333L3.16667 4.18C2.96418 4.29691 2.79599 4.46501 2.67897 4.66744C2.56196 4.86987 2.50024 5.09952 2.5 5.33333V10.6667C2.50024 10.9005 2.56196 11.1301 2.67897 11.3326C2.79599 11.535 2.96418 11.7031 3.16667 11.82L7.83333 14.4867Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 14.6667V8"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.69333 4.66667L8.5 8L14.3067 4.66667"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 2.84666L11.5 6.28"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CartIcon = ({ color = "#6A7282" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83333 14.6667C6.20152 14.6667 6.5 14.3682 6.5 14C6.5 13.6318 6.20152 13.3333 5.83333 13.3333C5.46514 13.3333 5.16667 13.6318 5.16667 14C5.16667 14.3682 5.46514 14.6667 5.83333 14.6667Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.1667 14.6667C13.5349 14.6667 13.8333 14.3682 13.8333 14C13.8333 13.6318 13.5349 13.3333 13.1667 13.3333C12.7985 13.3333 12.5 13.6318 12.5 14C12.5 14.3682 12.7985 14.6667 13.1667 14.6667Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.86666 1.36667H3.2L4.97333 9.64667C5.03838 9.94991 5.20711 10.221 5.45047 10.4132C5.69383 10.6055 5.9966 10.7069 6.30666 10.7H12.8267C13.1301 10.6995 13.4243 10.5955 13.6607 10.4052C13.897 10.2149 14.0614 9.94969 14.1267 9.65333L15.2267 4.7H3.91333"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HomeIcon = ({ color = "#6A7282" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 14V8.66667C10.5 8.48986 10.4298 8.32029 10.3047 8.19526C10.1797 8.07024 10.0101 8 9.83333 8H7.16667C6.98986 8 6.82029 8.07024 6.69526 8.19526C6.57024 8.32029 6.5 8.48986 6.5 8.66667V14"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 6.66667C2.49995 6.47271 2.54222 6.28108 2.62386 6.10515C2.70549 5.92921 2.82453 5.7732 2.97267 5.648L7.63933 1.648C7.87999 1.44461 8.1849 1.33302 8.5 1.33302C8.8151 1.33302 9.12001 1.44461 9.36067 1.648L14.0273 5.648C14.1755 5.7732 14.2945 5.92921 14.3761 6.10515C14.4578 6.28108 14.5 6.47271 14.5 6.66667V12.6667C14.5 13.0203 14.3595 13.3594 14.1095 13.6095C13.8594 13.8595 13.5203 14 13.1667 14H3.83333C3.47971 14 3.14057 13.8595 2.89052 13.6095C2.64048 13.3594 2.5 13.0203 2.5 12.6667V6.66667Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UsersIcon = ({ color = "#6A7282" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1667 14V12.6667C11.1667 11.9594 10.8857 11.2811 10.3856 10.781C9.88552 10.281 9.20724 10 8.5 10H4.5C3.79275 10 3.11448 10.281 2.61438 10.781C2.11428 11.2811 1.83333 11.9594 1.83333 12.6667V14"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1667 2.08534C11.7385 2.23359 12.2449 2.56752 12.6065 3.03472C12.968 3.50192 13.1641 4.07594 13.1641 4.66668C13.1641 5.25742 12.968 5.83144 12.6065 6.29863C12.2449 6.76583 11.7385 7.09976 11.1667 7.24801"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.1667 14V12.6667C15.1662 12.0758 14.9696 11.5019 14.6076 11.0349C14.2456 10.5679 13.7388 10.2344 13.1667 10.0867"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 7.33333C7.97276 7.33333 9.16667 6.13943 9.16667 4.66667C9.16667 3.19391 7.97276 2 6.5 2C5.02724 2 3.83333 3.19391 3.83333 4.66667C3.83333 6.13943 5.02724 7.33333 6.5 7.33333Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ClockIcon = ({
  color = "#6A7282",
  width = "16",
  height = "16",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 4V8L11.1667 9.33333"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 14.6667C12.1819 14.6667 15.1667 11.6819 15.1667 8.00001C15.1667 4.31811 12.1819 1.33334 8.5 1.33334C4.8181 1.33334 1.83333 4.31811 1.83333 8.00001C1.83333 11.6819 4.8181 14.6667 8.5 14.6667Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BarChartIcon = ({ color = "#6A7282" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 2V12.6667C2.5 13.0203 2.64048 13.3594 2.89052 13.6095C3.14057 13.8595 3.47971 14 3.83333 14H14.5"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 11.3333V6"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.16667 11.3333V3.33334"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83333 11.3333V9.33334"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SettingsIcon = ({ color = "#6A7282" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.94733 2.75732C6.98407 2.37088 7.16356 2.01202 7.45074 1.75084C7.73792 1.48967 8.11215 1.34494 8.50033 1.34494C8.88852 1.34494 9.26275 1.48967 9.54993 1.75084C9.83711 2.01202 10.0166 2.37088 10.0533 2.75732C10.0754 3.00696 10.1573 3.2476 10.2921 3.45888C10.4269 3.67016 10.6106 3.84586 10.8276 3.97111C11.0447 4.09635 11.2888 4.16746 11.5391 4.1784C11.7895 4.18935 12.0388 4.13981 12.266 4.03399C12.6187 3.87384 13.0185 3.85067 13.3873 3.96898C13.7562 4.08729 14.0679 4.33862 14.2617 4.67406C14.4555 5.00949 14.5175 5.40504 14.4358 5.7837C14.354 6.16237 14.1343 6.49707 13.8193 6.72266C13.6143 6.86655 13.4468 7.05773 13.3313 7.28001C13.2157 7.50228 13.1554 7.74913 13.1554 7.99966C13.1554 8.25018 13.2157 8.49703 13.3313 8.71931C13.4468 8.94158 13.6143 9.13276 13.8193 9.27666C14.1343 9.50224 14.354 9.83694 14.4358 10.2156C14.5175 10.5943 14.4555 10.9898 14.2617 11.3253C14.0679 11.6607 13.7562 11.912 13.3873 12.0303C13.0185 12.1486 12.6187 12.1255 12.266 11.9653C12.0388 11.8595 11.7895 11.81 11.5391 11.8209C11.2888 11.8319 11.0447 11.903 10.8276 12.0282C10.6106 12.1534 10.4269 12.3291 10.2921 12.5404C10.1573 12.7517 10.0754 12.9924 10.0533 13.242C10.0166 13.6284 9.83711 13.9873 9.54993 14.2485C9.26275 14.5096 8.88852 14.6544 8.50033 14.6544C8.11215 14.6544 7.73792 14.5096 7.45074 14.2485C7.16356 13.9873 6.98407 13.6284 6.94733 13.242C6.9253 12.9923 6.8434 12.7515 6.70858 12.5402C6.57376 12.3288 6.38998 12.1531 6.17282 12.0278C5.95566 11.9025 5.71151 11.8315 5.46105 11.8206C5.21059 11.8097 4.9612 11.8594 4.734 11.9653C4.38126 12.1255 3.98155 12.1486 3.61267 12.0303C3.24378 11.912 2.93212 11.6607 2.73832 11.3253C2.54453 10.9898 2.48248 10.5943 2.56424 10.2156C2.646 9.83694 2.86573 9.50224 3.18067 9.27666C3.38575 9.13276 3.55315 8.94158 3.66873 8.71931C3.7843 8.49703 3.84464 8.25018 3.84464 7.99966C3.84464 7.74913 3.7843 7.50228 3.66873 7.28001C3.55315 7.05773 3.38575 6.86655 3.18067 6.72266C2.86618 6.49695 2.64683 6.16239 2.56527 5.78398C2.4837 5.40557 2.54574 5.01035 2.73932 4.67513C2.93291 4.33991 3.24421 4.08864 3.61273 3.97015C3.98125 3.85166 4.38066 3.87441 4.73333 4.03399C4.96051 4.13981 5.20983 4.18935 5.4602 4.1784C5.71057 4.16746 5.95462 4.09635 6.17169 3.97111C6.38876 3.84586 6.57246 3.67016 6.70724 3.45888C6.84203 3.2476 6.92392 3.00696 6.946 2.75732"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 10C9.60457 10 10.5 9.10457 10.5 8C10.5 6.89543 9.60457 6 8.5 6C7.39543 6 6.5 6.89543 6.5 8C6.5 9.10457 7.39543 10 8.5 10Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChatIcon = ({ color = "#6A7282" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.1667 11.3333C15.1667 11.687 15.0262 12.0261 14.7761 12.2761C14.5261 12.5262 14.187 12.6667 13.8333 12.6667H5.052C4.69841 12.6667 4.35932 12.8073 4.10933 13.0573L2.64133 14.5253C2.57514 14.5915 2.4908 14.6366 2.39899 14.6548C2.30718 14.6731 2.21202 14.6637 2.12554 14.6279C2.03905 14.5921 1.96513 14.5314 1.91312 14.4536C1.86111 14.3758 1.83334 14.2843 1.83333 14.1907V3.33333C1.83333 2.97971 1.97381 2.64057 2.22386 2.39052C2.4739 2.14048 2.81304 2 3.16667 2H13.8333C14.187 2 14.5261 2.14048 14.7761 2.39052C15.0262 2.64057 15.1667 2.97971 15.1667 3.33333V11.3333Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EyeIcon = ({ color = "#6A7282" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.87467 8.232C1.81911 8.08232 1.81911 7.91767 1.87467 7.768C2.4158 6.4559 3.33434 5.33402 4.51385 4.5446C5.69335 3.75517 7.0807 3.33374 8.5 3.33374C9.9193 3.33374 11.3066 3.75517 12.4862 4.5446C13.6657 5.33402 14.5842 6.4559 15.1253 7.768C15.1809 7.91767 15.1809 8.08232 15.1253 8.232C14.5842 9.54409 13.6657 10.666 12.4862 11.4554C11.3066 12.2448 9.9193 12.6663 8.5 12.6663C7.0807 12.6663 5.69335 12.2448 4.51385 11.4554C3.33434 10.666 2.4158 9.54409 1.87467 8.232Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 10C9.60457 10 10.5 9.10457 10.5 8C10.5 6.89543 9.60457 6 8.5 6C7.39543 6 6.5 6.89543 6.5 8C6.5 9.10457 7.39543 10 8.5 10Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CouponIcon = ({ color = "#6A7282" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.89067 1.72398C8.64068 1.47391 8.30159 1.33339 7.948 1.33331H3.16667C2.81304 1.33331 2.4739 1.47379 2.22386 1.72384C1.97381 1.97389 1.83333 2.31302 1.83333 2.66665V7.44798C1.83341 7.80157 1.97393 8.14066 2.224 8.39065L8.02667 14.1933C8.32967 14.4944 8.7395 14.6634 9.16667 14.6634C9.59383 14.6634 10.0037 14.4944 10.3067 14.1933L14.6933 9.80665C14.9944 9.50364 15.1634 9.09382 15.1634 8.66665C15.1634 8.23948 14.9944 7.82966 14.6933 7.52665L8.89067 1.72398Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 5.33335C5.6841 5.33335 5.83333 5.18412 5.83333 5.00002C5.83333 4.81593 5.6841 4.66669 5.5 4.66669C5.31591 4.66669 5.16667 4.81593 5.16667 5.00002C5.16667 5.18412 5.31591 5.33335 5.5 5.33335Z"
      fill="#6A7282"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PromotionIcon = ({ color = "#6A7282" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1667 4.66669H15.1667V8.66669"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.1667 4.66669L9.5 10.3334L6.16667 7.00002L1.83333 11.3334"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EditStoreIcon = ({ color = "#6A7282" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 2H3.83333C3.47971 2 3.14057 2.14048 2.89052 2.39052C2.64048 2.64057 2.5 2.97971 2.5 3.33333V12.6667C2.5 13.0203 2.64048 13.3594 2.89052 13.6095C3.14057 13.8595 3.47971 14 3.83333 14H13.1667C13.5203 14 13.8594 13.8595 14.1095 13.6095C14.3595 13.3594 14.5 13.0203 14.5 12.6667V8"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.75 1.75003C13.0152 1.48481 13.3749 1.33582 13.75 1.33582C14.1251 1.33582 14.4848 1.48481 14.75 1.75003C15.0152 2.01525 15.1642 2.37496 15.1642 2.75003C15.1642 3.1251 15.0152 3.48481 14.75 3.75003L8.74133 9.75936C8.58303 9.91753 8.38747 10.0333 8.17267 10.096L6.25733 10.656C6.19997 10.6728 6.13916 10.6738 6.08127 10.6589C6.02339 10.6441 5.97055 10.614 5.9283 10.5717C5.88604 10.5295 5.85592 10.4766 5.84109 10.4188C5.82626 10.3609 5.82727 10.3001 5.844 10.2427L6.404 8.32736C6.46702 8.11273 6.58302 7.9174 6.74133 7.75936L12.75 1.75003Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
